// Portfolio Administration v1.0 PR 5 — color-coded status pill used by
// both the Vendors and Local Enforcers registries. The 5 status values
// (prospect / onboarding / active / suspended / terminated) follow the
// canonical spec §8 / §9 color scheme.

import { cn } from "@/design-system/lib/utils";

const STATUS_CLASSES: Record<string, string> = {
  prospect: "bg-gray-soft text-onyx",
  onboarding: "bg-status-warning/20 text-status-warning",
  active: "bg-status-success/20 text-status-success",
  suspended: "bg-status-warning/30 text-onyx",
  terminated: "bg-status-error/20 text-status-error",
};

export function RegistryStatusPill({ status }: { status: string }) {
  const normalized = status.toLowerCase();
  const klass = STATUS_CLASSES[normalized] ?? "bg-gray-soft text-onyx";
  return (
    <span
      className={cn(
        "inline-flex items-center px-space-2 py-[2px] rounded-sm text-[10px] font-display font-bold uppercase tracking-[0.16em]",
        klass,
      )}
      data-testid={`registry-status-pill-${normalized}`}
    >
      {status}
    </span>
  );
}
